import { render, staticRenderFns } from "./SummaryWeekly.vue?vue&type=template&id=b7824e98&"
import script from "./SummaryWeekly.vue?vue&type=script&lang=js&"
export * from "./SummaryWeekly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports